import { ReadonlySignal } from '@preact/signals-react';

import { OperationResult } from '@vp/common/core/OperationResult';
import { ProfileAccessModel } from '@vp/profile/core/model/ProfileAccessModel';

export abstract class AccessManagerPort {
  abstract readonly access: ReadonlySignal<ProfileAccessModel>;

  abstract apply(changes: ProfileAccessModel, controller?: AbortController): Promise<OperationResult>;
  abstract generateCode(): Promise<string>;
}
